import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet";
import Header from "../componets/Header";
import Footer from "../componets/Footer";
import { Link } from "react-router-dom";
import {
  fetchBannerData,
  fetchProductData,
  PincodeModalOpen,
  AddCardProductById,
  loginModalOpen,
  QtyOrderProductById,
} from "../reducer/thunks";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  message,
  Modal,
  Dropdown,
  Button,
  Popconfirm,
  Segmented,
  Select,
  InputNumber,
  Switch,
  Tooltip
} from "antd";
import SplashScreen from "../componets/SplashScreen";
import Banners from "../componets/Banners";
import {
  UserOutlined,
  ShoppingCartOutlined,
  DownOutlined,
  ArrowLeftOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import CardDrawer from "./CardDrawer";
import Carousel from "react-bootstrap/Carousel";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import './styles.css';

// import required modules
import { Pagination, Autoplay } from "swiper/modules";
import Bannersmenu from "../componets/Bannersmenu";
const popmod = {
  marginTop: "3%",
  // backgroundColor: "red",
};
const contentStyle = {
  margin: 0,
  height: "160px",
  color: "#fff",
  lineHeight: "160px",
  textAlign: "center",
  background: "#364d79",
};
const { Option } = Select;
const START_LAT = 12.9776435;
const START_LNG = 77.6386786;
const MAX_DISTANCE_KM = 10;

export default function Menu() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [product, setProduct] = useState([]);
  const [drawer, setDrawer] = useState(false);
  const [options, setOptions] = useState(false);
  const [optionslist, setOptionsArray] = useState([]);
  const [productid, setProductName] = useState("");
  const [menuselect, setMenuselect] = useState("");
  const [popconfirmVisible, setPopconfirmVisible] = useState(false);
  const [value, setValue] = useState("All");
  const [select, setSelect] = useState("");
  const [isenable, setenable] = useState(true);
  const [types, setTypes] = useState("");
  const [CustomizeOptions, setCustomizeOptions] = useState(false);
  const [Customizelist, setCustomizelist] = useState(null);
  
  // A state to track the expanded/collapsed view for descriptions
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const myElementRef = useRef(null); // Define a ref using useRef hook

  const [selectindex, setSelectIndex] = useState(0);
  const [selectedRiceType, setSelectedRiceType] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [searchResults, setSearchResults] = useState([]);



  // Haversine formula to calculate the distance between two lat/lng points
  const getDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radius of Earth in kilometers
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLng = (lon2 - lon1) * (Math.PI / 180);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) *
        Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in kilometers
  };
  const riceTypes = [
    { id: 0, name: "All", color: "#4A4A4A" }, // Dark Gray (Neutral)
    { id: 1, name: "Jeeraga Samba", color: "#8B4513" }, // Dark Brown (Closer to Jeera Samba's earthy tone)
    { id: 2, name: "Basmati", color: "#A68A64" }, // Deep Golden-Brown (More premium feel for Basmati)
    // { id: 3, name: "Cocktail", color: "#6B1F1F" }, // Dark Red-Brown (Mix of rice varieties)
  ];
  // Sample locations with coordinates (Latitude, Longitude) for distance calculation


  let pincodeId = localStorage.getItem("pincode");
  let userId = localStorage.getItem("userId");
 
  const currentLocation = { lat: 12.912, lng: 77.634 }; // Example current location (HSR Layout)

 
 const handleSearch = (input) => {
  if (!input) return setSearchResults([]); // Clear results if input is empty

  const service = new window.google.maps.places.AutocompleteService();
  service.getPlacePredictions(
    { input, types: ["geocode"], componentRestrictions: { country: "IN" } },
    async (predictions, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        // Get place details to filter by distance
        const placesService = new window.google.maps.places.PlacesService(
          document.createElement("div")
        );

        const validLocations = await Promise.all(
          predictions.map(
            (place) =>
              new Promise((resolve) => {
                placesService.getDetails(
                  { placeId: place.place_id, fields: ["geometry"] },
                  (details, status) => {
                    if (
                      status ===
                        window.google.maps.places.PlacesServiceStatus.OK &&
                      details?.geometry?.location
                    ) {
                      const lat = details.geometry.location.lat();
                      const lng = details.geometry.location.lng();
                      const distance = getDistance(START_LAT, START_LNG, lat, lng);

                      if (distance <= MAX_DISTANCE_KM) {
                        resolve(place); // Keep valid location
                      } else {
                        resolve(null); // Discard locations beyond 10 km
                      }
                    } else {
                      resolve(null);
                    }
                  }
                );
              })
          )
        );
        setenable(false)
        setSearchResults(validLocations.filter(Boolean)); // Remove null values
      }
    }
  );
};
  // Destructuring with different names to avoid conflict
  const {
    data,
    loading: bannerLoading,
    error: bannerError,
  } = useSelector((state) => state.data);
  const { GetAddcardUserRes } = useSelector((state) => state.GetAddcardUserRes);

  useEffect(() => {
    AOS.init({
      offset: 200,
      duration: 1000,
      // once: true
    });
    AOS.refresh();
  }, []);
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBoMO9HVyopxwZ5XzMiF1Xs7DVy8SU7NqY&libraries=places`;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const {
    productlist,
    loading: productListLoading,
    error: productListError,
  } = useSelector((state) => state.productlist);
  console.log(
    productlist && productlist.userProducts && productlist.userProducts,
    "product"
  );

  document.title = "Local Heros";
  document.getElementsByTagName("META")[2].content = "Local Heros";

  const handleNavigation = (productId) => {
    console.log(pincodeId);
    if (pincodeId !== null) {
      navigate(`/product/${productId}`);
    } else {
      dispatch(PincodeModalOpen(true));
    }
  };

  const onChange = (currentSlide) => {
    console.log(currentSlide);
  };

  const handleType = (key) => {
    switch (key) {
      case "Veg":
        return;
      case "Non Veg":
        return;
      case "Veg":
        return;

      default:
        break;
    }
  };

  const HandleDrawer = async (id, optionsID) => {
    if (userId) {
      let addcarditem = {
        userId: userId,
        productId: id,
        quantity: "1",
        Options_item: "",
        Combo_type: false,
        offline_type: false,
        Categrory_type: "",
      };
      await dispatch(AddCardProductById(addcarditem));
      if (optionsID) {
        let addcarditems = {
          userId: userId,
          productId: optionsID,
          quantity: "1",
          Options_item: "",
          Combo_type: false,
          offline_type: false,
          Categrory_type: "",
        };
        await dispatch(AddCardProductById(addcarditems));
      }
      setDrawer(!drawer);
    } else {
      message.info(`Pls select the login`, 5);
      await dispatch(loginModalOpen(true));
    }
  };
  useEffect(() => {
    dispatch(fetchBannerData());
    dispatch(fetchProductData());
  }, []);

  useEffect(() => {
    if (
      productlist?.userProducts &&
      data?.Categorys &&
      data?.Categorys.length > 0
    ) {
      changeMenu(data.Categorys[0]._id, 0); // Assuming you want to pass the ID of the first category
      const myElement = document.getElementById("myElement2");
      if (myElement) {
        // Do something with the element, for example, scroll to it
        myElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [data?.Categorys]); // Only trigger when data.Categorys changes
  const changeMenu = (id, index) => {
    setSelectIndex(index);
    setMenuselect(id);
  
    // Start with base filtering by category
    let filteredProducts = productlist.userProducts.filter(
      (product) => product.category === id
    );
  
    console.log(types, selectedRiceType, "selectedRiceType");
  
    // Further filter by `types` (if it's defined)
    if (types) {
      filteredProducts = filteredProducts.filter(
        (product) => product.is_type === types
      );
    }
  
    // Further filter by `selectedRiceType` (if it's defined)
    if (selectedRiceType) {
      filteredProducts = filteredProducts.filter(
        (product) => product.rice_type === selectedRiceType
      );
    }
  
    // Separate non-veg and veg (assuming is_veg: true for veg, false for non-veg)
    const nonVegProducts = filteredProducts.filter(product => product.is_type === "Non Veg");
    const vegProducts = filteredProducts.filter(product => product.is_type === "Veg");
  
    // Combine with non-veg first
    const finalProductList = [...nonVegProducts, ...vegProducts];
  
    // Handle filtering for index === 0
    if (index === 0) {
      const filteredProductOptions = productlist.userProducts.filter(
        (product) => product.category === "661133469875ecd47c09fe74"
      );
      setOptionsArray([...filteredProductOptions]);
    }
  
    // Update state with final filtered list
    setProduct([...finalProductList]);
  
    console.log("Updated Product State:", finalProductList);
  };
  

  const changeTabMenu = (type) => {
    let filteredProducts = [];
  
    if (types === "Veg") {
      // Deselect if already selected
      filteredProducts = productlist.userProducts.filter(
        (product) => product.category === menuselect
      );
  
      // Further filter by `selectedRiceType` (if it's defined)
      if (selectedRiceType) {
        filteredProducts = filteredProducts.filter(
          (product) => product.rice_type === selectedRiceType
        );
      }
  
      // Separate non-veg and veg
     // Separate non-veg and veg (assuming is_veg: true for veg, false for non-veg)
     const nonVegProducts = filteredProducts.filter(product => product.is_type === "Non Veg");
     const vegProducts = filteredProducts.filter(product => product.is_type === "Veg");
      const finalProductList = [...nonVegProducts, ...vegProducts];
  
      setTypes(type);
      setProduct([...finalProductList]);
      setTypes(null); // Optional: if you want to auto-deselect after showing
    } else {
      // Filter by type and category
      filteredProducts = productlist.userProducts.filter(
        (product) => product.is_type === type && product.category === menuselect
      );
  
      // Further filter by `selectedRiceType` (if it's defined)
      if (selectedRiceType) {
        filteredProducts = filteredProducts.filter(
          (product) => product.rice_type === selectedRiceType
        );
      }
  
      // Separate non-veg and veg
    // Separate non-veg and veg (assuming is_veg: true for veg, false for non-veg)
    const nonVegProducts = filteredProducts.filter(product => product.is_type === "Non Veg");
    const vegProducts = filteredProducts.filter(product => product.is_type === "Veg");
      const finalProductList = [...nonVegProducts, ...vegProducts];
  
      setTypes(type);
      setProduct([...finalProductList]);
    }
  };
  

  const changeTabMenuRice = (type) => {
    if (selectedRiceType === type.id || 0 === type.id) {
      // Deselect if already selected
      // Select and filter products
      let filteredProducts = productlist.userProducts.filter((product) => {
        return product.category === menuselect;
      });

      // Further filter by `types` (if it's defined)
      if (types) {
        filteredProducts = filteredProducts.filter(
          (product) => product.is_type === types
        );
      }

      setSelectedRiceType(type.id);
      setProduct([...filteredProducts]);
      setSelectedRiceType(0);
    } else {
      // Select and filter products
      let filteredProducts = productlist.userProducts.filter((product) => {
        return product.rice_type === type.id && product.category === menuselect;
      });
      // Further filter by `types` (if it's defined)
      if (types) {
        filteredProducts = filteredProducts.filter(
          (product) => product.is_type === types
        );
      }
      setSelectedRiceType(type.id);
      setProduct([...filteredProducts]);
    }
  };

  const getProductPath = (productId) => {
    if (pincodeId && userId) {
      return `/product/${productId}`;
    } else {
      if (pincodeId) {
        message.info(`Pls select the login`, 5);
      } else if (userId) {
        message.info(`login in once can you select the product`, 5);
      }
    }
  };
  const renderDynamicValues = (dataFromBackend) => {
    // Split the string by both commas and '\n' to get an array of lines
    const lines = dataFromBackend.split(/[+\n]/);

    // Filter out any empty or whitespace-only lines
    const filteredLines = lines.filter((line) => line.trim() !== "");

    // Map each line to a <li> tag wrapped in a <ul>
    const listItems = filteredLines.map((line, index) => (
      <li key={index}>{line.trim()}</li>
    ));

    // Return the list items wrapped in a <ul>
    return (
      <ul className="text-black text-start fs-6 list-style">{listItems}</ul>
    );
  };

  const renderDynamicValue = (dataFromBackend) => {
    // Split the string by both commas and '\n' to get an array of lines
    const lines = dataFromBackend.split(/[.\n]/);

    // Filter out any empty or whitespace-only lines
    const filteredLines = lines.filter((line) => line.trim() !== "");

    // Map each line to a <li> tag wrapped in a <ul>
    const listItems = filteredLines.map((line, index) => (
      <li key={index}>{line.trim()}</li>
    ));

    // Return the list items wrapped in a <ul>
    return (
      <ul className="text-black text-start fs-6 list-style">{listItems}</ul>
    );
  };

  const handleOpenChange = (visible) => {
    console.log("open change");
    setPopconfirmVisible(visible);
  };

  const handleClick = (id, menuItem) => {
    // Check if the menu item matches the desired value
    // Accessing the element by its ID and performing actions
    const myElement = document.getElementById("myElement2");
    if (myElement) {
      // Do something with the element, for example, scroll to it
      myElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  const handleUpdateQuantity = async (prod_id, qtynumber) => {
    console.log(prod_id, qtynumber, "qtynumber", qtynumber > 0);
    if (Math.sign(qtynumber) !== -1) {
      let prod_qty = {
        quantity: String(qtynumber),
        savelater: false,
      };
      dispatch(QtyOrderProductById(prod_qty, prod_id));
    }
  };
  const handleUpdateQuantitys = async (prod_id, qtynumber) => {
    console.log(prod_id, qtynumber, "qtynumber", qtynumber > 0);
    let addcarditem = {
      userId: userId,
      productId: prod_id,
      quantity: "1",
      Options_item: "",
      Combo_type: false,
      offline_type: false,
      Categrory_type: "",
    };
    await dispatch(AddCardProductById(addcarditem));
  };

  const handleUpdateCard = async (prod_id, qtynumber) => {
    let addcarditem = {
      userId: userId,
      productId: prod_id,
      quantity: "1",
      Options_item: "",
      Combo_type: false,
      offline_type: true,
      Categrory_type: "65d885c1e5d7ac618080e397",
    };
    await dispatch(AddCardProductById(addcarditem));
  };
  const handleDescriptionToggle = (id) => {
    // Toggle the state of the expanded description for the given id
    setExpandedDescriptions((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const onHandleOptions = (item) => {
    if (item.options) {
      setOptions(true);
      setPopconfirmVisible(true);
      setProductName(item._id);
    } else {
      HandleDrawer(item._id, "");
      setProductName("");
    }
  };

  // Function to get the quantity of a product
  const getProductQuantity = (productId) => {
    const product = GetAddcardUserRes?.AddCarts?.find(
      (item) => item.productId === productId
    );
    return product ? product.quantity : 0; // Return the quantity or 0 if not found
  };

  // Function to get the quantity of a product
  const getTotalProductQuantity = () => {
    return (
      GetAddcardUserRes?.AddCarts?.reduce(
        (total, item) => total + (item.offline_type ? item.quantity : 0),
        0 // Initial total is 0
      ) ?? 0
    ); // Default to 0 if no products exist
  };

  // Function to get the quantity of a product
  const getProductQuantityId = (productId) => {
    const product = GetAddcardUserRes?.AddCarts?.find(
      (item) => item.productId === productId
    );
    return product._id; // Return the quantity or 0 if not found
  };

  const selectItem = (item, prod_id, index) => {
    // HandleDrawer(item, prod_id);
    // setOptions(false);
    setSelect(index);
  };

  const confirm = () =>
    new Promise((resolve) => {
      setTimeout(() => resolve(null), 3000);
      setPopconfirmVisible(false); // Optionally close the Popconfirm after confirmation
    });

  if (!data) {
    return <SplashScreen />;
  }
  return (
    <>
      <Helmet>
        <title>Local Heros</title>
        <meta
          name="description"
          content="This is a description of your page."
        />
        <meta name="keywords" content="local heroes, community, volunteer" />
      </Helmet>
      <div className="zindex-card">
        <CardDrawer
          openDrawer={drawer}
          onClose={() => {
            setDrawer(!drawer);
          }}
        />
        <Header onTabclick={handleClick} />
      </div>

      {/* <Bannersmenu /> */}

      <section className="py-5" id="" ref={myElementRef}>
        <div className="container mt-70">
          <div className="row justify-content-center ">
            <div className="col-md-12 text-center mb-4">
              {/* <h2 className="theme-color menu-text font-hp">Menu</h2> */}
            </div>
            <p class="text-center anim p-3 mb-4">
              <span class="">
                "All the prices mentioned are inclusive of taxes, premium
                packaging and zero cost delivery on orders above Rs 297"
              </span>
            </p>
          </div>
          <div className="delivery-container">
            <div className="delivery-left">
              <span>Delivery</span>
              <div className="delivery-separator"></div>
              <Tooltip title="Please search for a neat location" open={selectedLocation && !selectedLocation.length > 0}>
              <div className="delivery-address">
                <EnvironmentOutlined className="mx-2 fs-5" />
                <Select
                  showSearch
                  value={selectedLocation}
                  className="responsive-box"
                  onChange={(value) => setSelectedLocation(value)}
                  bordered={false}
                  onSearch={handleSearch}
                  filterOption={false} // Disable default filtering since API handles it
                >
                  {searchResults.map((place) => (
                    <Select.Option
                      key={place.place_id}
                      value={place.description}
                    >
                      {place.description}
                    </Select.Option>
                  ))}
                </Select>
              </div>
              </Tooltip>
            </div>
            {/* <div className="change-address">Change</div> */}
          </div>
          <div className="col-md-12 text-end mb-4 d-flex justify-content-between mt-2">
            {/* Rice Type Filter Buttons */}

            <div className="rice-type-container">
            <span className="card-container filter-label d-md-block d-none"> Rice Type </span>

              {riceTypes.map((rice) => (
                <button
                disabled={isenable}
                  key={rice.id}
                  className={`btn-vna-rice fw-semibold ${
                    selectedRiceType === rice.id ? "active" : ""
                  }`}
                  style={{
                    border:
                      selectedRiceType === rice.id
                        ? `0px solid ${rice.color}`
                        : `2px solid ${rice.color}`,
                    color: selectedRiceType === rice.id ? "#fff" : rice.color,
                    fontSize: "smaller",
                    backgroundColor:
                      selectedRiceType === rice.id ? rice.color : "transparent",
                  }}
                  onClick={() => changeTabMenuRice(rice)}
                >
                  {rice.name}
                </button>
              ))}
            </div>

            <div className="card-container d-flex justify-content-center align-items-center">
              <div className="label-container" style={{ textAlign: "center" }}>
                <span
                  className="label-name"
                  style={{
                    fontWeight: "bold",
                    fontSize: "0.9em",
                    color: types === "Veg" ? "green" : "black",
                    marginRight: "10px",
                  }}
                >
                  {"Veg only"}
                </span>
              </div>

              <Switch
                size="small"
                checked={types === "Veg"}
                onChange={(value) => {
                  if (value) {
                    changeTabMenu("Veg");
                  } else {
                    changeTabMenu("Non Veg");
                  }
                }}
                style={{
                  backgroundColor: types === "Veg" ? "green" : "black",
                }}
              />
            </div>
          </div>

          {/* Category Selection Tabs */}
          <div className="d-md-block d-none">
            <ul
              className="nav nav-pills mb-3 categoryCard_wrapper col-md-12"
              id="pills-tab"
              role="tablist"
            >
              {data?.Categorys?.map((item, index) => (
                <li key={index} role="presentation">
                  <button
                    disabled={isenable}
                    className={`nav-link categoryCard mg-0 overflow-hidden`}
                    id={`pills-${item.name.toLowerCase()}-tab`}
                    data-bs-toggle="pill"
                    onClick={() => {
                      changeMenu(item._id, index);
                      document
                        .getElementById("Menuid")
                        ?.scrollIntoView({ behavior: "smooth" });
                      if (index === 5) setCustomizeOptions(true);
                    }}
                    type="button"
                    role="tab"
                    aria-controls={`pills-${item.name.toLowerCase()}`}
                    aria-selected={index === 0 ? "true" : "false"}
                  >
                    <img
                      src={item.imageUrl}
                      className={`img-fluid image-card ${ isenable && "gray-image"}`}
                      width="190px"
                      height="180px"
                      alt="menu"
                    />
                    <p className="mb-0 itm-na">
                      <span className="d-block my-auto">{item.name}</span>
                      {item.subname && (
                        <span className="d-block my-auto mt-1">
                          ({item.subname})
                        </span>
                      )}
                    </p>
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="d-md-none d-block">
            <Swiper
              slidesPerView={3}
              spaceBetween={10}
              // autoplay={{
              //   delay: 3000, // Delay in ms between auto scrolls
              //   disableOnInteraction: false, // Whether to pause autoplay when user interacts
              // }}
              modules={[Pagination, Autoplay]} // Add Autoplay to the modules array
              className="mySwiper"
            >
              {data &&
                data.Categorys &&
                data.Categorys.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="card-swip " role="presentation">
                      <button
                        className={`nav-link categoryCard ${
                          index === 0 ? "" : ""
                        }`}
                        id={`pills-${item.name.toLowerCase()}-tab`}
                        onClick={() => {
                          changeMenu(item._id, index);
                          const myElement = document.getElementById(`${item}`);
                          if (myElement) {
                            myElement.scrollIntoView({ behavior: "smooth" });
                          }
                          if (index === 5) {
                            setCustomizeOptions(true);
                          }
                        }}
                        type="button"
                        role="tab"
                        aria-controls={`pills-${item.name.toLowerCase()}`}
                        aria-selected={index === 0 ? "true" : "false"}
                      >
                        <img
                          src={`${item.imageUrl}`}
                          className={`img-fluid rounded-circle image-card ${ isenable && "gray-image"}`}
                          width="200px"
                          height="200px"
                          alt="menu"
                        />
                        <p className="mb-0 itm-na">
                          <span className="d-block my-auto">{item.name}</span>
                        </p>
                      </button>
                    </div>
                  </SwiperSlide>
                ))}
            </Swiper>
          </div>

          {
            <div className="menu-box-bg d-md-block d-none" id="Menuid">
              <div className="row justify-content-center">
                <div className="col-md-12 mb-5 text-center">
                  <div class="tab-content">
                    <div className="row d-flex justify-content-center">
                      {data &&
                        product &&
                        product.map((item) => (
                          <React.Fragment>
                            <div  className="col-md-3 mb-3 ">
                              <div className="menu-box rounded ">
                                {item?.images.length > 1 ? (
                                  <Carousel
                                    afterChange={onChange}
                                    interval={3000}
                                    indicators={true}
                                    controls={false}
                                    wrap={true}
                                  >
                                    {item.images.map((image, index) => (
                                      <Carousel.Item key={index}>
                                        <img
                                          src={image}
                                          className={`img-fluid menu-box-img rounded w-100 ${ isenable && "gray-image"}`}
                                          alt={`menu ${index}`}
                                          onClick={() =>
                                            handleNavigation(item._id)
                                          }
                                        />
                                      </Carousel.Item>
                                    ))}
                                  </Carousel>
                                ) : (
                                  <img
                                    src={item.images[0]}
                                    className={`img-fluid rounded w-100 menu-box-img ${ isenable && "gray-image"}`}
                                    alt="menu"
                                    onClick={() => handleNavigation(item._id)}
                                  />
                                )}

                                <div className="d-flex justify-content-between">
                                  <h3 className="text-black text-start px-2 fs-6">
                                    {item.name.includes("(")
                                      ? item.name.split("(")[0]
                                      : item.name}
                                  </h3>
                                  <div></div>
                                  <div>
                                    {item.is_type === "Non Veg" ? (
                                      <img
                                        src={require("../constant/images/non-veg.jpg")}
                                        alt="veg"
                                        className="veg_nonveg_icon"
                                      />
                                    ) : (
                                      <img
                                        src={require("../constant/images/veg-image.jpg")}
                                        alt="nonveg"
                                        className="veg_nonveg_icon"
                                      />
                                    )}
                                  </div>
                                </div>

                                <div className="row d-flex align-items-center">
                                  <div className="col-lg-12 text-end mb-0">
                                    <h3 className="price-button text-black fs-5 d-flex w-100 ">
                                      ₹{item.amount}
                                      {"\t"}
                                      <span
                                        className="text-black text-start fontsize-12 mt-1 mx-1
                                      "
                                      >
                                        {`(${item.subname})`}
                                      </span>
                                      {/* <span className=" text-danger stickout-price ms-3 strik-price">
                                    ₹ {item.offeramount}
                                  </span> */}
                                    </h3>
                                  </div>
                                </div>

                                {/* Show description with a "view more" option */}

                                {item.description && (
                                  <div className="text-black fs-6 text-start px-2 d-none">
                                    {expandedDescriptions[item._id] ? (
                                      <span>
                                        {" "}
                                        {selectindex === 2 || selectindex === 3
                                          ? renderDynamicValues(
                                              item.description
                                            )
                                          : item.description}
                                      </span>
                                    ) : (
                                      <span>
                                        {" "}
                                        {item.description.slice(0, 70)}{" "}
                                      </span>
                                    )}
                                    {item.description.length > 75 &&
                                      !expandedDescriptions[item._id] &&
                                      "..."}
                                    <div className="d-flex justify-content-center align-items-center">
                                      <p
                                        className="text-black border border-dark rounded mt-1 p-1 w-auto"
                                        onClick={() =>
                                          handleDescriptionToggle(item._id)
                                        }
                                      >
                                        {expandedDescriptions[item._id]
                                          ? "Read Less"
                                          : "Read More"}
                                      </p>
                                    </div>
                                  </div>
                                )}

                                <p className="text-dark line-space-with">
                                  <span className="ms-2 ">
                                    {item.description !== "" &&
                                    expandedDescriptions[item._id]
                                      ? item.description
                                      : item.description.slice(0, 35) + "..."}
                                  </span>
                                </p>

                                <div
                                  className="d-flex justify-content-around align-items-center"
                                  style={{ cursor: "pointer" }}
                                >
                                  <div className="d-flex justify-content-center align-items-center ">
                                    <button
                                      disabled={isenable}
                                      className="text-black border border-dark w-100 px-2  add-card-button  bg-white"
                                      onClick={() =>
                                        handleDescriptionToggle(item._id)
                                      }
                                    >
                                      <span className="fontsize-12">
                                        {expandedDescriptions[item._id]
                                          ? "Read Less"
                                          : "Read More"}
                                      </span>
                                    </button>
                                  </div>

                                  <button
                                    onClick={() => onHandleOptions(item)}
                                    className="add-card-button"
                                    disabled={isenable}

                                  >
                                    <span className="fontsize-12">Add +</span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </React.Fragment>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          {
            <div className="menu-box-bg d-md-none d-block ">
              <div className="row justify-content-center">
                <div className="col-md-12 mb-5 text-center">
                  <div class="tab-content">
                    <div className="row d-flex justify-content-center">
                      {data &&
                        product &&
                        product.map((item) => (
                          <React.Fragment>
                            <div className="col-md-4 mb-3 ">
                              <div className="row d-flex align-items-center">
                                <div className="col-7">
                                  <div className="">
                                    <div className="text-start px-2">
                                      {item.is_type === "Non Veg" ? (
                                        <img
                                          src={require("../constant/images/non-veg.jpg")}
                                          alt="veg"
                                          className="veg_nonveg_icon"
                                        />
                                      ) : (
                                        <img
                                          src={require("../constant/images/veg-image.jpg")}
                                          alt="nonveg"
                                          className="veg_nonveg_icon"
                                        />
                                      )}
                                    </div>
                                    <h6 className="font-sw text-black text-start px-2">
                                      {item.name.includes("(")
                                        ? item.name.split("(")[0]
                                        : item.name}
                                    </h6>
                                    <h6 className="font-sw price-button text-black d-flex w-100">
                                      ₹{item.amount}{" "}
                                    </h6>
                                    <div></div>
                                  </div>

                                  {item.subname !== "" && (
                                    <p className="text-black text-start px-2 font-saz">
                                      (Inclusive of taxes, premium packaging and
                                      ZCD)
                                    </p>
                                  )}

                                  {item.description && (
                                    <div className="text-black fs-6 text-start px-2 d-none">
                                      {expandedDescriptions[item._id] ? (
                                        <span>
                                          {" "}
                                          {selectindex === 2 ||
                                          selectindex === 3
                                            ? renderDynamicValues(
                                                item.description
                                              )
                                            : item.description}
                                        </span>
                                      ) : (
                                        <span>
                                          {" "}
                                          {item.description.slice(0, 70)}{" "}
                                        </span>
                                      )}
                                      {item.description.length > 75 &&
                                        !expandedDescriptions[item._id] &&
                                        "..."}
                                      <div className="d-flex justify-content-center align-items-center">
                                        <p
                                          className="text-black border border-dark rounded mt-1 p-1 w-auto"
                                          onClick={() =>
                                            handleDescriptionToggle(item._id)
                                          }
                                        >
                                          {expandedDescriptions[item._id]
                                            ? "Read Less"
                                            : "Read More"}
                                        </p>
                                      </div>
                                    </div>
                                  )}

                                  <p className="text-dark line-space-with d-none">
                                    <span className="ms-2 ">
                                      {item.description !== "" &&
                                      expandedDescriptions[item._id]
                                        ? item.description
                                        : item.description.slice(0, 40) + "..."}
                                    </span>
                                  </p>
                                </div>
                                <div className="col-5 pos-rel">
                                  {" "}
                                  {item?.images.length > 1 ? (
                                    <Carousel
                                      afterChange={onChange}
                                      interval={3000}
                                      indicators={true}
                                      controls={false}
                                      wrap={true}
                                    >
                                      {item.images.map((image, index) => (
                                        <Carousel.Item key={index}>
                                          <img
                                            src={image}
                                            className={`img-fluid menu-box-img rounded w-100${ isenable && "gray-image"}`}
                                            alt={`menu ${index}`}
                                            onClick={() =>
                                              handleNavigation(item._id)
                                            }
                                          />
                                        </Carousel.Item>
                                      ))}
                                    </Carousel>
                                  ) : (
                                    <img
                                      src={item.images[0]}
                                      className={`rounded w-100 menu-box-img1 ${ isenable && "gray-image"}`}
                                      alt="menu"
                                      onClick={() => handleNavigation(item._id)}
                                    />
                                  )}
                                  <button
                                   disabled={isenable}
                                    onClick={() => onHandleOptions(item)}
                                    className="pos-ab"
                                  >
                                    Add +
                                  </button>
                                </div>
                              </div>

                              <div
                                className="d-flex justify-content-around align-items-center"
                                style={{ cursor: "pointer" }}
                              >
                                <div className="d-flex justify-content-center align-items-center ">
                                  <button
                                    className="text-black border border-dark w-auto px-4 add-card-button bg-white d-none"
                                    onClick={() =>
                                      handleDescriptionToggle(item._id)
                                    }
                                  >
                                    {expandedDescriptions[item._id]
                                      ? "Read Less"
                                      : "Read More"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </React.Fragment>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </section>
      <Footer />
      <Modal
        visible={CustomizeOptions}
        onCancel={() => {
          setOptions(false);
          setCustomizeOptions(false);
          setCustomizelist(null);
        }}
        height="300px"
        width="1000px"
        style={popmod}
        className="reghu"
        footer={null}
      >
        <h4 className="text-center text-black font-weight-bold head-control mt-4 mb-5 d-flex justify-content-between align-items-center">
          <div
            onClick={() => {
              setCustomizelist(null);
            }}
          >
            <ArrowLeftOutlined />
          </div>{" "}
          {!Customizelist ? "Customise your biryani" : Customizelist?.name}{" "}
          <div></div>
        </h4>
        <section>
          <div className="d-flex justify-content-end mt-3 mb-2">
            {/* <Button
                className="mx-2"
                type="primary"
                onClick={() => {
                  HandleDrawer(productid, "");
                  setOptions(false);
                }}
              >
                Skip
              </Button> */}
            <Button
              onClick={() => {
                const totalQuantity = getTotalProductQuantity(); // Get the total selected quantity

                // Check if the total quantity is within the allowed limit
                if (totalQuantity === Number(Customizelist.allow_select)) {
                  // Allow the user to proceed, as the limit hasn't been reached
                  navigate(`/checkout`);
                } else {
                  // Limit exceeded, show an error message
                  message.error(
                    `You can only select up to ${Number(
                      Customizelist.allow_select
                    )} Biryani. ${Customizelist.name}`
                  );
                }
              }}
              danger
            >
              Proceed Next
            </Button>
          </div>
        </section>
        <div className="row justify-content-center align-items-center">
          {Customizelist
            ? data &&
              productlist.userProducts.map(
                (item, index) =>
                  item.category === "65d8859be5d7ac618080e395" && (
                    <div
                      className="col-md-3 col-6 mb-4"
                      key={item._id}
                      onClick={() => selectItem(productid, item._id, index)}
                    >
                      <div
                        className={`keb-card ${
                          select === index ? "image-hovers" : "image-hover"
                        }`}
                      >
                        <div className="food-rel">
                          <img
                            src={item.images[0]}
                            className={`w-100 rounded`}
                            alt="menu"
                          />
                        </div>
                        <div className=" justify-content-center mt-3 line-space-with prod-nam-pri">
                          <div className="">
                            <p
                              className="text-black mb-md-2"
                              style={{ fontWeight: 700 }}
                            >
                              {item.name.includes("(")
                                ? item.name.split("(")[0]
                                : item.name}{" "}
                            </p>
                            <div className="d-flex justify-content-end align-items-end mb-md-2">
                              <button
                                className="quantity-btn"
                                onClick={() => {
                                  if (
                                    Math.sign(
                                      getProductQuantity(item._id) - 1
                                    ) !== -1
                                  ) {
                                    handleUpdateQuantity(
                                      getProductQuantityId(item._id),
                                      getProductQuantity(item._id) - 1
                                    );
                                  } else {
                                    message.error(
                                      "The quantity is not available in Item",
                                      3
                                    );
                                  }
                                }}
                                disabled={item.quantity <= 1}
                              >
                                -
                              </button>
                              <span className="quantity">
                                {" "}
                                {getProductQuantity(item._id)}
                              </span>
                              <button
                                className="quantity-btn"
                                onClick={() => {
                                  const totalQuantity =
                                    getTotalProductQuantity();
                                  const productQuantity = getProductQuantity(
                                    item._id
                                  );
                                  console.log(
                                    Number(Customizelist.allow_select) >
                                      totalQuantity,
                                    Number(Customizelist.allow_select),
                                    totalQuantity
                                  );

                                  if (
                                    Number(Customizelist.allow_select) >
                                    totalQuantity
                                  ) {
                                    handleUpdateCard(
                                      item._id,
                                      productQuantity + 1
                                    );
                                  } else {
                                    message.error(
                                      `You can only select up to ${Number(
                                        Customizelist.allow_select
                                      )} Biryani.`
                                    );
                                  }
                                }}
                              >
                                +
                              </button>
                            </div>
                          </div>
                          <section>
                            <div className="d-flex justify-content-end mt-3">
                              {/* <Button
                className="mx-2"
                type="primary"
                onClick={() => {
                  HandleDrawer(productid, "");
                  setOptions(false);
                }}
              >
                Skip
              </Button> */}
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  )
              )
            : data &&
              data.Categorys &&
              data.Categorys.map(
                (item, index) =>
                  item.product_by === true && (
                    <div
                      className="col-md-3 col-6 mb-4"
                      key={item._id}
                      onClick={() => setCustomizelist(item)}
                    >
                      <div
                        className={`keb-card ${
                          select === index ? "image-hovers" : "image-hover"
                        }`}
                      >
                        <div className="food-rel">
                          <img
                            src={item?.imageUrl}
                            className={`w-100 rounded`}
                            alt="menu"
                          />
                        </div>
                        <div className=" justify-content-center mt-3 line-space-with prod-nam-pri">
                          <div className=" text-center ">
                            <p
                              className="text-black mb-md-2 fs-5"
                              style={{ fontWeight: 700 }}
                            >
                              {item.name.includes("(")
                                ? item.name.split("(")[0]
                                : item.name}{" "}
                            </p>
                          </div>

                          <div className="text-center">
                            <p>{item.subname ? item.subname : item.subname}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
              )}
        </div>
      </Modal>
      <Modal
        visible={options}
        onCancel={() => {
          setOptions(false);
          setCustomizeOptions(false);
          setCustomizelist(null);
        }}
        height="300px"
        width="1000px"
        style={popmod}
        className="reghu"
        footer={null}
      >
        <h4 className="text-center text-black font-weight-bold head-control mt-4 mb-5">
          Make The Box Of Joy A Box Of Celebration By Adding Juicy Kababs
        </h4>

        <div className="row">
          {data &&
            optionslist &&
            optionslist.map((item, index) => (
              <div
                className="col-md-3 col-6 mb-4"
                key={item._id}
                onClick={() => selectItem(productid, item._id, index)}
              >
                <div
                  className={`keb-card ${
                    select === index ? "image-hovers" : "image-hover"
                  }`}
                >
                  <div className="food-rel">
                    <img
                      src={item.images[0]}
                      className={`w-100 rounded`}
                      alt="menu"
                    />
                  </div>
                  <div className=" justify-content-center mt-3 line-space-with prod-nam-pri">
                    <div className="prod-nam-pri2">
                      <p
                        className="text-black mb-md-2"
                        style={{ fontWeight: 700 }}
                      >
                        {item.name.includes("(")
                          ? item.name.split("(")[0]
                          : item.name}{" "}
                      </p>
                      <div className="d-flex justify-content-end align-items-end mb-md-2">
                        <button
                          className="quantity-btn"
                          onClick={() => {
                            if (
                              Math.sign(getProductQuantity(item._id) - 1) !== -1
                            ) {
                              handleUpdateQuantity(
                                getProductQuantityId(item._id),
                                getProductQuantity(item._id) - 1
                              );
                            } else {
                              message.error(
                                "The quantity is not available in Item",
                                3
                              );
                            }
                          }}
                          disabled={item.quantity <= 1}
                        >
                          -
                        </button>
                        <span className="quantity">
                          {" "}
                          {getProductQuantity(item._id)}
                        </span>
                        <button
                          className="quantity-btn"
                          onClick={() =>
                            handleUpdateQuantitys(
                              item._id,
                              getProductQuantity(item._id) + 1
                            )
                          }
                        >
                          +
                        </button>
                      </div>
                    </div>

                    <div className="prod-nam-pri2">
                      <p>{item.subname ? item.subname : item.subname}</p>
                      <p className="text-black prod-pric"> ₹{item.amount} </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}

          <section>
            <div className="d-flex justify-content-end mt-3">
              {/* <Button
                className="mx-2"
                type="primary"
                onClick={() => {
                  HandleDrawer(productid, "");
                  setOptions(false);
                }}
              >
                Skip
              </Button> */}
              <Button
                onClick={() => {
                  if (select === 0) {
                    // HandleDrawer(optionslist[select]._id, productid);
                    HandleDrawer(productid, "");
                  } else {
                    // HandleDrawer(optionslist[select]._id, productid);
                    HandleDrawer(productid, "");
                  }
                  setOptions(false);
                }}
                danger
              >
                Proceed
              </Button>
            </div>
          </section>
        </div>
      </Modal>
    </>
  );
}
